import React from "react";
import { ConfigProvider, DatePicker as AntdDatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import 'dayjs/locale/es';    // Spanish
import ptBR from "antd/locale/pt_BR";
import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";
import { GetAppLang, IsMobileOrTablet } from "Utilities/utils";

dayjs.locale("pt-br");

const localeMap = {
  Pt: ptBR,
  En: enUS,
  Es: esES,
};

const getAntdLocale = () => {
    const lang = GetAppLang();
    return localeMap[lang] || localeMap.En;
};

const getFormat = (mode, showTime) => {
    const lang = GetAppLang();

    const formats = {
        Pt: {
            date: "DD/MM/YYYY",
            datetime: "DD/MM/YYYY HH:mm:ss",
            year: "YYYY",
            inputDate: "DD/MM/YYYY",
            inputDatetime: "DD/MM/YYYY HH:mm:ss",
        },
        Es: {
            date: "DD/MM/YYYY",
            datetime: "DD/MM/YYYY HH:mm:ss",
            year: "YYYY",
            inputDate: "DD/MM/YYYY",
            inputDatetime: "DD/MM/YYYY HH:mm:ss",
        },
        En: {
            date: "MM/DD/YYYY",
            datetime: "MM/DD/YYYY HH:mm:ss",
            year: "YYYY",
            inputDate: "MM/DD/YYYY",
            inputDatetime: "MM/DD/YYYY HH:mm:ss",
        },
    };

    const f = formats[lang] || formats.En;

    if (mode === "year") return f.year;
    if (showTime) return f.datetime;
    return f.date;
};

export function DisplayDateAsString(dateInput, displayTime = false) {
  try {
    if (!dateInput) return "";

    const dateObj = dayjs(dateInput);
    if (!dateObj.isValid()) return "";

    const appLang = GetAppLang(); // Pt | En | Es

    const formatMap = {
      Pt: displayTime
        ? "DD/MM/YYYY HH:mm:ss"
        : "DD/MM/YYYY",

      Es: displayTime
        ? "DD/MM/YYYY HH:mm:ss"
        : "DD/MM/YYYY",

      En: displayTime
        ? "MM/DD/YYYY HH:mm:ss"
        : "MM/DD/YYYY",
    };

    const format = formatMap[appLang] || formatMap.EN;

    return dateObj.format(format);

  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function DateToString(params) {
  try {
    if (!params?.date?.isValid?.()) return "";

    const appLang = GetAppLang(); // Pt | En | Es

    const formatMap = {
      Pt: params.displayTime
        ? "DD/MM/YYYY HH:mm:ss"
        : "DD/MM/YYYY",

      Es: params.displayTime
        ? "DD/MM/YYYY HH:mm:ss"
        : "DD/MM/YYYY",

      En: params.displayTime
        ? "MM/DD/YYYY HH:mm:ss"
        : "MM/DD/YYYY",
    };

    const format = formatMap[appLang] || formatMap.En;

    return params.date.format(format);

  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function DisplayGridDatetime(params) {
  const isoString = params.value;

  if (!isoString) {
    return '';
  }

  const dateObj = dayjs(isoString);

  if (!dateObj.isValid()) {
    return '';
  }

  const appLang = GetAppLang(); // Pt | En | Es

  const formatMap = {
    Pt: "DD/MM/YYYY HH:mm:ss",
    Es: "DD/MM/YYYY HH:mm:ss",
    En: "MM/DD/YYYY HH:mm:ss",
  };

  const format = formatMap[appLang] || formatMap.En;

  return dateObj.format(format);
}
export function DisplayGridDate(params) {
  const isoString = params.value;

  if (!isoString) {
    return '';
  }

  const dateObj = dayjs(isoString);

  if (!dateObj.isValid()) {
    return '';
  }

  const appLang = GetAppLang(); // Pt | En | Es

  const formatMap = {
    Pt: "DD/MM/YYYY",
    Es: "DD/MM/YYYY",
    En: "MM/DD/YYYY",
  };

  const format = formatMap[appLang] || formatMap.En;

  return dateObj.format(format);
}
export function DateToIsoString(fromDate) {
  try {
    return fromDate?.isValid?.() ? fromDate.format("YYYY-MM-DDTHH:mm:ss") : "";
  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function DateFromIsoString(isoString) {
  try {
    return isoString ? dayjs(isoString) : dayjs();
  } catch (e) {
    console.warn("Failed to parse date", e);
    return dayjs();
  }
}
export function InitDateToIsoString(fromDate) {
  try {
    return fromDate?.isValid?.() ? fromDate.format("YYYY-MM-DDTHH:mm:ss") : "";
  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function InitDateFromIsoString(isoString) {
  try {
    const baseDate = isoString ? dayjs(isoString).set('hour', 0).set('minute', 0).set('second', 0) : dayjs();
    return baseDate;
  } catch (e) {
    console.warn("Failed to parse date", e);
  }
}
export function FinDateToIsoString(fromDate) {
  try {
    return fromDate?.isValid?.() ? fromDate.format("YYYY-MM-DDTHH:mm:ss") : "";
  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function FinDateFromIsoString(isoString) {
  try {
    const baseDate = isoString ? dayjs(isoString).set('hour', 23).set('minute', 59).set('second', 59) : dayjs();
    return baseDate;
  } catch (e) {
    console.warn("Failed to parse date", e);
  }
}
export function setDefaultOrderInitDate(){
  return(dayjs().set('hour', 0).set('minute', 0).set('second', 0));
}
export function setDefaultInitDate(){
  return(dayjs().set('hour', 0).set('minute', 0).set('second', 0));
}
export function setDefaultFinalDate(){
  return(dayjs().add(7,'day').set('hour', 23).set('minute', 59).set('second', 59));
}
export function compareInitFinDate(dt0, dt1) {
  return (dayjs(dt0) < dayjs(dt1)) ?  true : false;
}
export function getDateNow() {
    return (dayjs());
}
export function getDateNowYearString() {
    return (dayjs().format('YYYY'));
}
export function getDateInEnglish() {
  const now = dayjs().locale('en');
  return {
    month: now.format('MMMM'),
    year: now.year()
  };
}
export function getDateInPortuguese() {
  const now = dayjs().locale('pt-br');
  return {
    month: now.format('MMMM'),
    year: now.year()
  };
}
export function getDateInSpanish() {
  const now = dayjs().locale('es');
  return {
    month: now.format('MMMM'),
    year: now.year()
  };
}

export const DatePicker = ({
  value,
  onChange,
  mode = "date",
  showTime = false,
  picker,
  ...props
}) => {
    const normalizeValue = () => {
        if (!value) return null;

        if (value?.isValid?.()) return value;

        if (mode === "year" && typeof value === "number") {
            return dayjs(`${value}`, "YYYY");
        }

        return dayjs(value);
    };

    const handleChange = (date) => {
        if (!onChange) return;

        if (mode === "year") {
            onChange(date ? date.year() : null);
        } else {
            onChange(date ?? null);
        }
    };

    const format = getFormat(mode, showTime);

    const isDesktop = !IsMobileOrTablet();
    const popupClassName = isDesktop  ? "app-datepicker-popup-desktop" : "app-datepicker-popup-mobile";
    return (
        <ConfigProvider locale={getAntdLocale()}>
            <AntdDatePicker
                {...props}
                picker={picker || (mode === "year" ? "year" : "date")}
                value={normalizeValue()}
                onChange={handleChange}
                format={format}
                showTime={showTime ? { format: "HH:mm:ss" } : undefined}
                allowClear
                placement="bottomLeft"
                inputReadOnly={props.inputReadOnly}
                needConfirm={props.needConfirm}
                style={{
                    width: "100%",
                    ...(props.style || {}),
                }}
                classNames={{
                    ...(props.classNames || {}),
                    popup: {
                        ...(props.classNames?.popup || {}),
                        root: [
                            props.classNames?.popup?.root,
                            popupClassName,
                        ]
                            .filter(Boolean)
                            .join(" "),
                    },
                }}
                styles={{
                    ...(props.styles || {}),
                    popup: {
                        ...(props.styles?.popup || {}),
                        root: {
                            zIndex: isDesktop ? undefined : 9000,
                            ...(props.styles?.popup?.root || {}),
                        },
                    },
                }}
                popupClassName={popupClassName}
                dropdownClassName={popupClassName}
            />
        </ConfigProvider>
    );
};
/*
export const DatePickerDynamic = ({ value, onChange: onChangeProp, picker, ...props }) => {

    const normalizeValue = () => {
        if (!value) return null;

        // already dayjs
        if (value?.isValid?.()) return value;

        // year picker
        if (picker === "year" && typeof value === "number") {
            return dayjs(`${value}`, "YYYY");
        }

        // fallback
        return dayjs(value);
    };

    const handleChange = (date) => {
        if (!onChangeProp) return;

        // returns a number
        if (picker === "year") {
            onChangeProp(date ? date.year() : null);
        } 
        else {
            onChangeProp(date ?? null);
        }
    };

    return (
        <ConfigProvider>
            <AntdDatePicker
                {...props}
                picker={picker}
                value={normalizeValue()}
                onChange={handleChange}
                allowClear
            />
        </ConfigProvider>
    );
};
export const DatePicker = ({ value, onChange: onChangeProp, ...props }) => {
  const handleChange = (date) => {
    if (onChangeProp) {
      if (date === null) {
        onChangeProp(dayjs());
      }
      else {
        onChangeProp(date);
      }
    }
  };

  const handleFormatTyping = (e) => {
    let v = e.target.value.replace(/\D/g, "").slice(0, 7);
  
    if (v.length >= 5) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
    } else if (v.length >= 3) {
      v = `${v.slice(0, 2)}/${v.slice(2)}`;
    }
  
    e.target.value = v;
  }
  return (
    <ConfigProvider locale={ptBR}>
      <AntdDatePicker
        {...props}
        format="DD/MM/YYYY"
        value={value} // now strictly a dayjs object
        onChange={handleChange}
        onKeyDown={handleFormatTyping}
        allowClear
      />
    </ConfigProvider>
  );
};
export const DateTimePicker = ({ value, onChange: onChangeProp, ...props }) => {
  
  const handleChange = (date) => {
    if (onChangeProp) {
      onChangeProp(date);
    }
  };

  const handleInput = (e) => {
    let v = e.target.value.replace(/\D/g, "").slice(0, 14);
    let formatted = v;

    if (v.length > 2) formatted = `${v.slice(0, 2)}/${v.slice(2)}`;
    if (v.length > 4) formatted = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
    if (v.length > 8) formatted = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)} ${v.slice(8)}`;
    if (v.length > 10) formatted = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)} ${v.slice(8, 10)}:${v.slice(10)}`;
    if (v.length > 12) formatted = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)} ${v.slice(8, 10)}:${v.slice(10, 12)}:${v.slice(12)}`;

    e.target.value = formatted;
  };

  return (
    <ConfigProvider locale={ptBR}>
      <AntdDatePicker
        {...props}
        showTime={{ format: "HH:mm:ss" }}
        format="DD/MM/YYYY HH:mm:ss" 
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        onInput={handleInput}
        allowClear
      />
    </ConfigProvider>
  );
};
*/